/* 平台创建的排班-时刻表-编辑模式 */
<template>
  <div id="schedulingPlatformTimeForm">

    <!-- 编辑值班车辆 -->
    <schedulingVehicle :visible.sync="schedulingVehicleShow" :line="lineInfo" :scheduling="editShiftForm"
                       :vehicleId.sync="editShiftVehicleId" @confirm="vehicleConfirm"/>

    <!-- 导入班次时间表 -->
    <el-dialog class="dialog-export-modal" :visible.sync="visibleImport" title="" width="1000px"
               :close-on-click-modal="false">
      <template slot="title">
        <span>导入班次</span>
        <el-button type="text" style="font-size: 14px;" @click="downloadFn">下载模板</el-button>
      </template>
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <div>
          <p class="util-remark">1.只能导入当前机构的车辆，车辆必须绑定司机</p>
          <p class="util-remark">2.导入的时间段只能是00:00-24:00之间，导入失败的数据需要您手动补充</p>
        </div>
      </div>
      <el-upload class="upload-demo" accept=".xls,.xlsx" drag :on-change="handleChange" :auto-upload="false"
                 :show-file-list="false" action="/api/v1/common/excel/read/import">
        将导入模版拖至该区域或手动选择模版
      </el-upload>
    </el-dialog>

    <div class="schedulingPlatformTimeForm-head">
      <div class="schedulingPlatformTimeForm-head-left">
        <img class="icon-line" src="../../../assets/img/line.png" alt=""/>
        <span style="font-weight: 600">{{ lineInfo.startStationName }} - {{ lineInfo.endStationName }}</span>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="save" :loading="loading">保存</el-button>
        <el-button @click="$router.replace({ path: '/schedulingTimeForm', query: { id: lineId } })">取消</el-button>
      </div>
    </div>

    <!-- 班次列表 -->
    <div class="schedulingPlatformTimeForm-body">
      <div class="scheduling-form-date">
        <div class="left">
          <custom-across-roll ref="customAcrossRoll">
            <div class="date" :class="dateActiveIndex == i ? 'active' : ''" v-for="(scheduling, i) in schedulingJson"
                 :key="i" @click="dateClick(scheduling, i)" @mouseover="dateHover('over', i, scheduling)"
                 @mouseout="dateHover('out', i)">
              <span class="date-text">{{ getWeek(scheduling.schedulingTime) }}
                {{ scheduling.schedulingTime | filterTime("MM-DD") }}</span>
              <span class="date-close" :class="scheduling.removeIconShow ? 'remove' : ''"
                    @click.stop="removeSchedulingTime(scheduling, i)">×</span>
            </div>
            <div class="date" v-if="schedulingJson.length < 30" @click="copyScheduling">复制排班</div>
          </custom-across-roll>
        </div>
        <el-button v-if="schedulingJson.length < 30" @click="addScheduling">添加日期</el-button>
      </div>

      <div class="scheduling-form-table">

        <el-form :model="form" ref="form" label-width="0">
          <el-table :data="form.shiftActive" border style="width: 100%">
            <el-table-column prop="startTime" label="班次时间" width="200">
              <template slot-scope="{row,$index}">
                <el-form-item :prop="'shiftActive.' + $index + '.startTime'"
                              :rules="[{ validator: validateStart, trigger: 'change' }]">
                  <el-time-picker v-if="row.isNew" v-model="row.startTime" format="HH:mm" value-format="HH:mm"
                                  :default-value="form.shiftActive[row.realIndex - 1] && form.shiftActive[row.realIndex - 1].startTime
                    ? new Date(2000, 1, 1, form.shiftActive[row.realIndex - 1].startTime.split(':')[0], Number(form.shiftActive[row.realIndex - 1].startTime.split(':')[1]))
                    : new Date()"></el-time-picker>
                  <span v-else>{{ row.startTime }}</span>
                </el-form-item>
              </template>
            </el-table-column>

            <!--            <el-table-column prop="endTime" label="发车时间" width="200">-->
            <!--              <template slot-scope="{row,$index}">-->
            <!--                <div>-->
            <!--                  <el-form-item v-if="row.isNew" :prop="'shiftActive.' + $index + '.endTime'"-->
            <!--                                :rules="[{ validator: validateEnd, trigger: 'change' }]">-->
            <!--                    <el-time-picker v-model="row.endTime" format="HH:mm"-->
            <!--                                    :default-value="row.startTime ? new Date(2000, 1, 1, row.startTime.split(':')[0], Number(row.startTime.split(':')[1])) : new Date()"-->
            <!--                                    value-format="HH:mm"></el-time-picker>-->
            <!--                  </el-form-item>-->
            <!--                  <span v-else>{{ row.endTime }}</span>-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </el-table-column>-->

            <el-table-column prop="licenseNo" label="车辆号牌" v-slot="{ row,$index }">

              <el-button type="text" @click="editVehicle(row,$index)">
                {{
                  row.schedulingVehicleJson && row.schedulingVehicleJson[0] ? row.schedulingVehicleJson[0].licenseNo : '添加'
                }}
              </el-button>


            </el-table-column>

            <el-table-column prop="vehicleNo" label="车辆编号" v-slot="{ row }">
              <!--              <template v-if="row.isNew">{{ row.vehicleNo || '-' }}</template>-->
              <template> {{ row.schedulingVehicleJson && row.schedulingVehicleJson[0].vehicleNo || '-' }}</template>
            </el-table-column>
            <el-table-column prop="vehicleModel" label="车型" v-slot="{ row }">
              <!--              <template v-if="row.isNew">{{ row.vehicleModel }}</template>-->
              <template> {{ row.schedulingVehicleJson && row.schedulingVehicleJson[0].vehicleModel }}</template>
            </el-table-column>
            <el-table-column prop="vehicleSeat" label="座位数" v-slot="{ row }">
              <!--              <template v-if="row.isNew">{{ row.vehicleSeat }}</template>-->
              <template> {{ row.schedulingVehicleJson && row.schedulingVehicleJson[0].vehicleSeat }}</template>
            </el-table-column>


            <el-table-column prop="address" label="操作" width="180">
              <template slot-scope="{$index,row}">

                <el-button type="text" @click="addShift($index)" v-if="row.status == 1">向上插班</el-button>
                <el-button v-if="row.soldTickets == 0" @click="removeFn(row, $index)" type="text">删除</el-button>
                <span v-else class="tips" style="margin-left:10px">有人购票无法删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>

        <div class="shiftPush">
          <div class="add" @click="addShift"><i class="el-icon-plus"></i>添加班次</div>
          <div class="add" @click="visibleImport = true"><i class="el-icon-plus"></i>导入班次</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulingPlatformTimeForm",
  components: {
    customAcrossRoll: () => import("@/components/custom-across-roll.vue"),
    schedulingVehicle: () => import("./schedulingVehicle.vue"),
  },
  data() {
    return {
      lineId: this.$route.query.id,
      detailTitle: "线路票价",
      schedulingVehicleShow: false,
      // 表单对象
      form: {
        // 当前选中的日期班次
        shiftActive: [],
      },
      // 线路详情信息
      lineInfo: {},
      //线路详情数据
      priceForm: {
        stationRailFee: [],
      },

      // 加载中
      loading: false,

      schedulingJson: [],
      // 选中的日期索引
      dateActiveIndex: 0,
      //点击查看座位数据
      seats: [],

      lineOId: "",

      // 编辑司机的班次
      editShiftForm: {},
      // 编辑司机的班次的车辆Id
      editShiftVehicleId: null,

      // 所有日期的值班司机
      dutyDrivers: [],

      // 导入班次时间相关参数
      visibleImport: false,

      editShiftIndex: 0,

      /* 检票时间验证器 */
      validateStart: (rule, value, callback) => {
        let arr = rule.fullField.split(".");
        let i = Number(arr[1]);
        let item = this.form.shiftActive[i].startTime;
        let prevItem = i > 0 ? this.form.shiftActive[i - 1].startTime : null;
        let nextItem = this.form.shiftActive[i + 1] ? this.form.shiftActive[i + 1].startTime : null;
        if (!value) {
          callback(new Error("“接人/检票时间”不能为空"));
        } else if (i > 0 && prevItem && item < prevItem) {
          callback(new Error("请设置大于等于上个班次的“接人/检票时间”"));
        } else if (i < 15 && nextItem && item > nextItem) {
          callback(new Error("请设置小于等于下个班次的“接人/检票时间”"));
        } else {
          callback();
        }
      },
      /* 预计发车验证器 */
      validateEnd: (rule, value, callback) => {
        let arr = rule.fullField.split(".");
        let i = Number(arr[1]);
        let endTime = this.form.shiftActive[i].endTime;
        let startItem = this.form.shiftActive[i].startTime;
        if (!value) {
          callback(new Error("发车时间不能为空"));
        } else if (endTime < startItem) {
          callback(new Error("不能小于“接人/检票时间”"));
        } else {
          callback();
        }
      },
    };
  },
  watch: {
    "form.shiftActive"(item) {
      if (this.dutyDrivers[0]) {
        this.$emit('dutyDriversUpdate', this.dutyDrivers[this.dateActiveIndex])
      }
    }
  },

  async created() {
    await this.getInfo(this.$route.query.schedulingTime);
  },

  methods: {
    /* 添加日期 */
    async addScheduling() {
      let last = this.schedulingJson[this.schedulingJson.length - 1];
      let row = {
        isNew: true,
        removeIconShow: false,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift: [],
      };
      this.dutyDrivers.push({
        isNew: true,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        vehicleInfo: []
      })
      this.schedulingJson.push(row);

      this.dateClick(this.schedulingJson[this.schedulingJson.length - 1], this.schedulingJson.length - 1)

      this.$nextTick(() => {
        this.$refs.customAcrossRoll.navNext();
      })
    },

    /* 添加班次 index:插班下标 */
    addShift(index) {
      let row = {
        status: 1,
        startTime: "",
        endTime: "",
        // ticketNumType: 1,
        ticketNum: 0,
        remainingTickets: 0,
        soldTickets: 0,
        show: true,
        addStatus: true,
        isNew: true,
        licenseNo: null,
        vehicleModel: null,
      };
      if (this.lineInfo.schedulingType == 1 || this.lineInfo.schedulingType == 3) {
        row.ticketNumType = 2;
      }
      if (typeof index == "number") {
        // 插班 
        row.realIndex = index;
        this.form.shiftActive.map((item, i) => {
          if (i > index) {
            ++item.realIndex;
          }
        })
        this.form.shiftActive.splice(index, 0, row);
      } else {
        // 添加

        row.realIndex = this.form.shiftActive.length;

        console.log(row, 1111);
        this.form.shiftActive.push(row);

      }

      this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
    },
    /* 日期鼠标悬浮 */
    async dateHover(type, i, row) {
      if (type == "over" && row.isNew) {
        this.schedulingJson[i].removeIconShow = true;
      }
      if (type == "out") {
        this.schedulingJson[i].removeIconShow = false;
      }
    },
    /* 复制排班 */
    copyScheduling() {
      let last = JSON.parse(JSON.stringify(this.schedulingJson[this.schedulingJson.length - 1]));

      let shift = JSON.parse(JSON.stringify(last.shift))


      shift = shift.map((item, index) => {
        return {
          ...item,
          status: 1,
          soldTickets: 0,
          remainingTickets: item.schedulingVehicleJson && item.schedulingVehicleJson[0].vehicleSeat - 1,
          ticketNum: item.schedulingVehicleJson && item.schedulingVehicleJson[0].vehicleSeat - 1,
          registerType: null,
          registerTime: null,
          registerUser: null,
          registerUserId: null,
          id: null,
          schedulingVehicleJson: item.schedulingVehicleJson,
          realIndex: index,
          isNew: true,
        }
      })

      let row = {
        ...last,
        isNew: true,
        removeIconShow: false,
        schedulingTime: last.schedulingTime + 24 * 60 * 60,
        shift: shift
      };

      this.schedulingJson.push(row);


      this.dateClick(this.schedulingJson[this.schedulingJson.length - 1], this.schedulingJson.length - 1)

      this.$nextTick(() => {
        this.$refs.customAcrossRoll.navNext();
      })
    },
    // 保存
    save() {
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          let url = "/api/v1/manage/line/scheduling/add";

          // 排班班次JSON
          let schedulingJson = [];
          // 违规数据记录
          let violationTips = ''
          this.schedulingJson.map(scheduling => {
            console.log(scheduling, 111);
            let violationBl = false;
            if (scheduling.shift) {
              scheduling.shift = scheduling.shift.map((item) => {
                return {
                  ...item,
                  schedulingVehicleJson: item.schedulingVehicleJson ? item.schedulingVehicleJson : [],
                  endTime: item.startTime
                }
              })
              violationBl = scheduling.shift.find((item, index, arr) => {
                if (item.ticketNumType == 2 && !item.ticketNum && this.lineInfo.schedulingType == 2) {
                  return true
                }
                console.log(2);
                if (!item.startTime || !item.endTime) {
                  return true
                }
                // if (item.startTime > item.endTime) {
                //   return true
                // }
                console.log(3);
                if (index > 0 && item.startTime < arr[index - 1].startTime) {
                  return true
                }
                console.log(4);
                if (index < arr.length - 1 && item.startTime > arr[index + 1].startTime) {
                  return true
                }
                // console.log(5);
                // if (!item.schedulingVehicleJson || !item.schedulingVehicleJson[0].licenseNo) {
                //   return true
                // }
                console.log(6);
              })
            } else if (scheduling.isNew) {
              violationBl = true;
            }
            if (violationBl) {
              violationTips += this.$utils.timeFn(scheduling.schedulingTime, "MM-DD") + ' '
            }

            if (scheduling.isNew) {
              schedulingJson.push(scheduling);
            } else {
              let newRows = [];
              if (scheduling.shift) {
                newRows = scheduling.shift.filter(item => item.isNew || item.isEdit)
              }
              if (newRows.length > 0) {
                schedulingJson.push({
                  schedulingTime: scheduling.schedulingTime,
                  shift: newRows,
                })
              }
            }
          })
          if (violationTips) {
            this.$message.warning(`请检查【${violationTips}】班次信息和车辆是否正确`);
            return;
          }

          let params = {
            lineId: this.lineId,
            schedulingJson: schedulingJson[0] ? JSON.stringify(schedulingJson) : null
          };
          this.loading = true
          let data = await this.$axios.post(url, params);
          this.loading = false
          if (data && data.code == 1) {
            this.$message.success('已保存');
            this.$router.replace({path: "/schedulingTimeForm", query: {id: this.lineId}});
          }
        } else {
          this.$message.warning(`请检查数据输入是否正确！`);
          return false;
        }
      });
    },

    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },

    /* 删除班次 */
    removeFn(row, index) {

      console.log(row, 111);
      let sort = () => {
        this.form.shiftActive.splice(index, 1);
        this.form.shiftActive = this.form.shiftActive.map((item, i) => {
          if (i > index) {
            item.realIndex--
          }
          return item
        })
        console.log(this.form.shiftActive, 1111);

        this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
      }
      if (row.id) {
        this.$confirm(`确认删除之前创建的班次吗？删除后立即生效`, "提示").then(async () => {
          let url = "/api/v1/manage/line/scheduling/" + row.id;
          let data = await this.$axios.delete(url);
          if (data && data.code == 1) {
            this.$message.success('班次已删除');
            sort();
          }
        })
      } else {
        sort();
      }

    },

    /* 点击日期按钮 */
    async dateClick(item, i) {
      this.dateActiveIndex = i;
      console.log(item, 43434334);
      this.form.shiftActive = item.shift || [];
    },

    /* 删除某个排班日期 */
    async removeSchedulingTime(scheduling, i) {
      let date = this.$utils.timeFn(this.schedulingJson[i].schedulingTime, "MM-DD");
      this.$confirm(`确认删除该日期(${date})下全部班次吗？`, "删除提示").then(async () => {
        if (this.schedulingJson.length > 0 && i == this.schedulingJson.length - 1) {
          this.schedulingJson.pop();
          this.dutyDrivers.pop();
          this.dateClick(scheduling, i - 1)
        } else {
          scheduling.shift = []
          this.dateClick(scheduling, i)
        }
      });
    },

    /* 编辑值班车辆 */
    async editVehicle(row, index) {
      this.schedulingVehicleShow = true;
      this.editShiftForm = row;
      this.editShiftIndex = index
      this.editShiftVehicleId = row.schedulingVehicleJson ? (row.schedulingVehicleJson[0].id || row.schedulingVehicleJson[0].vehicleId) : null;
    },

    /* 确定值班车辆 */
    async vehicleConfirm(result) {

      // // 更新行票数
      // this.editShiftForm.soldTickets = 0;
      // this.editShiftForm.ticketNum = result.vehicleSeat - 1;
      // this.editShiftForm.remainingTickets = result.vehicleSeat - 1;
      // this.editShiftForm.licenseNo = result.licenseNo;
      // this.editShiftForm.vehicleNo = result.vehicleNo;
      // this.editShiftForm.vehicleModel = result.vehicleModel;
      // this.editShiftForm.vehicleSeat = result.vehicleSeat;
      // delete result.vehicleSeatAndFeeVos;
      // this.editShiftForm.isEdit = true;
      // this.editShiftForm.schedulingVehicleJson = [{...result}];
      if (this.form.shiftActive[this.editShiftIndex].id) {
        const url = '/api/v1/manage/line/scheduling/vehicle'
        const params = {
          schedulingId: this.form.shiftActive[this.editShiftIndex].id,
          ...result,
        };
        const {code} = await this.$axios.post(url, params);
        if (code === 1) {
          this.$message.success(`车辆已修改`);
        }
      }

      this.$set(this.form.shiftActive, this.editShiftIndex, {
        ...this.form.shiftActive[this.editShiftIndex],
        remainingTickets: result.vehicleSeat - 1,
        ticketNum: result.vehicleSeat - 1,
        schedulingVehicleJson: [result]
      })
    },

    /* 获取平台排班信息 schedulingTime 指定日期 */
    async getInfo(schedulingTime) {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let res = await this.$axios.get(url, {channel: 1});
      if (res?.code == 1) {
        res = res.data;
        this.lineOId = res?.line?.organizationId;
        this.schedulingJson = [];
        let currentList = [];
        if (res.scheduling?.length > 0) {
          currentList = res.scheduling.map((item) => {
            let soldTicketsSum = 0;
            if (item.shift && item.shift.length > 0) {
              soldTicketsSum = item.shift.reduce(function (prev, cur) {
                return cur.soldTickets + prev;
              }, 0);
            }
            item.soldTicketsSum = soldTicketsSum;
            return item;
          });

          let times1 = res.lineVehicleList ? res.lineVehicleList.map((item) => item.schedulingTime) : [];
          let times2 = res.scheduling ? res.scheduling.map((item) => item.schedulingTime) : [];
          let times = Array.from(new Set([...times1, ...times2]));
          currentList.forEach((item) => {
            let target = times.find((time) => time == item.schedulingTime);
            // 判断是不是已有的数据
            if (target) {
              // 班次信息数据初始化
              this.schedulingJson.push(item);
            }
          });

          if (schedulingTime) {
            this.dateActiveIndex = currentList.findIndex(item => item.schedulingTime == schedulingTime)
          }
          this.form.shiftActive = currentList && currentList.length > 0 && currentList[this.dateActiveIndex].shift ? currentList[this.dateActiveIndex].shift : [];

        } else {
          // 班次为空情况下
          let tomorrow = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点

          this.schedulingJson.push({
            isNew: true,
            schedulingTime: tomorrow,
            shift: [],
          });

          this.dutyDrivers.push({
            isNew: true,
            schedulingTime: tomorrow,
            vehicleInfo: []
          })

          this.form.shiftActive = [];
        }
        this.lineInfo = res.line || {};
        this.$emit("infoUpdate", this.lineInfo);

      }
    },

    /* 下载导入班次模板 */
    downloadFn() {

      if (this.mixinUserInfo.platformType === 2) {
        window.open('/stationScheduling.xlsx');
      } else {
        window.open('/scheduling.xlsx');
      }

    },

    /* 待上传文件变化 */
    handleChange(val) {
      if (!/\.(xls|xlsx)$/.test(val.name)) {
        this.$message.warning("只能导入.xls，.xlsx类型的文件", "warning");
        return false;
      }
      this.uploadFn(val);
    },

    /* 获取excel排班文件列表 */
    async uploadFn(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("excelType", this.mixinUserInfo.platformType === 2 ? 'StationSchedulingStandard' : 'SchedulingStandard');
      formData.append("organizationId", this.lineInfo.organizationId);
      let data = await this.$axios.post(
          "/api/v1/common/excel/read/import",
          formData
      );
      if (data && data.code == 1 && data.data) {
        this.importShift(data.data)
      }
    },

    /* 导入班次 index:插班下标 */
    importShift(excelList) {
      excelList.map(item => {
        let row = {
          status: 1,
          startTime: item.startTime,
          endTime: item.endTime,
          // ticketNumType: 1,
          ticketNum: item.ticketNum,
          remainingTickets: item.remainingTickets,
          soldTickets: 0,
          show: true,
          addStatus: true,
          isNew: true,
          realIndex: this.form.shiftActive.length,
          schedulingVehicleJson: null,
          licenseNo: null,
          vehicleNo: null,
          vehicleModel: null,
          vehicleSeat: null
        };
        if (item.schedulingVehicleJson[0].vehicleId) {
          row.schedulingVehicleJson = item.schedulingVehicleJson;
          row.licenseNo = item.schedulingVehicleJson[0].licenseNo;
          row.vehicleNo = item.schedulingVehicleJson[0].vehicleNo;
          row.vehicleModel = item.schedulingVehicleJson[0].vehicleModel;
          row.vehicleSeat = item.schedulingVehicleJson[0].vehicleSeat;
        }
        this.form.shiftActive.push(row);
      })

      this.schedulingJson[this.dateActiveIndex].shift = this.form.shiftActive;
      this.$message.success("导入成功！");
      this.visibleImport = false;
    },
  },
};
</script>

<style lang="less" scoped>
#schedulingPlatformTimeForm {
  .schedulingPlatformTimeForm-head {
    padding-bottom: 10px;
    border-bottom: 1px rgb(221, 221, 221) solid;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: #333333;

      .icon-line {
        width: 20px;
        margin-right: 8px;
        height: auto;
      }

      .icon-type {
        font-size: 16px;
        margin-left: 22px;
        font-weight: 500;
        line-height: 30px;
        border-radius: 4px;
        color: #409efc;
        padding: 2px 8px;
        background: rgba(64, 158, 252, 0.1);
      }

      .line-money {
        display: flex;
        align-items: center;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        height: 36px;
        padding: 0 12px;
        margin-left: 22px;

        img {
          width: 20px;
          height: auto;
          margin-right: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }

  .schedulingPlatformTimeForm-body {
    display: flex;
    flex-flow: column;

    .statusSearch {
      margin: 20px 0 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div:nth-child(1) {
        display: flex;
        align-items: center;
      }
    }

    .el-input {
      min-width: 100px;
      width: 100%;
    }

    .ticket-num {
      width: 110px;

      /deep/ input {
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .scheduling-form-date {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;

    .left {
      flex-grow: 1;
      margin-right: 12px;
      overflow: hidden;
    }
  }

  .scheduling-form-table {
    width: 100%;

    /deep/ .el-table__cell {
      // padding: 0;
    }

    /deep/ .is-error {
      padding-bottom: 25px;
    }

    .el-input__inner {
      width: 100%;
    }

    .el-radio-group {
      display: flex;
      align-items: center;

      .el-input-group__append {
        padding: 0 6px;
      }
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ebeef5 !important;
      outline: none;

      th,
      td {
        height: 38px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        width: 130px;
        border-color: #ebeef5 !important;
        box-sizing: border-box;
        padding: 0 12px;
      }

      th {
        background-color: #fafafa;
        text-align: left;
      }

      .gray td {
        color: #999 !important;
      }
    }

    .table_scheduling {
      .el-button {
        margin-left: 0;
        margin-right: 10px;
      }

      .th1,
      .th5,
      .th7,
      .th8 {
        width: 80px;
      }

      .th6 {
        width: 120px;
      }

      .th4 {
        width: 160px;
        padding: 12px;
        line-height: 20px;
      }
    }

    .el-form-item__error {
      z-index: 10;
      white-space: nowrap;
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-radio {
    position: relative;
    top: 1.5px;
  }

  .motoal {
    text-align: center;
    margin-top: 20px;
  }

  // 禁用input的number箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /deep/ .el-dialog {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 20px;
    }

    .el-input-group__prepend {
      padding: 0 10px;
    }

    .el-input-group .el-input__inner {
      border-radius: 0px 4px 4px 0 !important;
      border-right: 1px solid #dcdfe6 !important;
    }
  }
}

.updatePrice {
  margin-top: -20px;
  margin-bottom: 20px;

  .detail {
    font-size: 17px;
    font-weight: bolder;
    padding-right: 10px;
  }

  .update {
    cursor: pointer;
    color: #0288ff;
  }
}

.submit {
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 100px;
    padding: 7px 15px;
  }
}

.shiftPush {
  display: flex;
  justify-content: space-between;
}

.add {
  flex-grow: 1;
  margin-top: 12px;
  border: 1px #ebebeb dashed;
  line-height: 28px;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-color: @color-primary;
    color: @color-primary;
  }

  &:nth-child(1) {
    margin-right: 20px
  }
}

.upload-demo {
  width: 100%;
  margin-top: 20px;

  /deep/ .el-upload,
  /deep/ .el-upload-dragger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
